const areaZh = {
  area: {
    selectArea: "选择区域",
    HongKong: "中国香港",
    Singapore: "新加坡",
    Macau: "中国澳门",
    China: "中国大陆",
    Japan: "日本",
    Korea: "韩国",
    Thailand: "泰国",
  },
};

export default areaZh;
